<template>
  <v-row>
    <v-dialog v-model="visible" persistent max-width="900px">
      <v-card :loading="loading">
        <v-card-title>
          <span class="headline">{{ $t("modal.multiAssign.title") }}</span>
        </v-card-title>

        <v-card-subtitle>
          <b>{{ totalSelectedCases }}</b> {{ $t("modal.multiAssign.subTitle") }}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                dense
                style="font-size: 1em"
                :label="$t('modal.multiAssign.label.assignee')"
                v-model="assignedToUser"
                :items="getUsersWithUnassigned"
                :item-text="item => {return getTextForUserSelect(item)}"
                item-value="email"
                return-object
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="comment"
                :placeholder="$t('modal.multiAssign.label.commentOptional')"
                dense
                rows="1"
                counter
                maxlength="500"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onCancel">{{
            $t("label.cancel")
          }}</v-btn>
          <v-btn
            :disabled="assignedToUser.name == null"
            color="blue darken-1"
            @click="updateAssignee"
            :loading="loading"
            >{{ $t("label.save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import {getTextForUserSelect} from "../../utils/userUtils"
export default {
  name: "BulkAssign",
  data() {
    return {
      assignedToUser: {},
      comment: "",
    };
  },
  computed: {
    ...mapGetters(["users"]),
    getUsersWithUnassigned: function () {
      var users = [...this.users];
      users.push({ email: null, name: "Unassigned" });
      return users;
    }
  },
  props: {
    error: {},
    totalSelectedCases: Number,
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    visible: function(val){
      if(!val){
        this.assignedToUser = {};
        this.comment = null;
      }
    }
  },
  methods: {
    getTextForUserSelect,
    updateAssignee() {
      this.$emit("onConfirm", this.assignedToUser.email, this.comment);
    },
    onCancel() {
      this.$emit("onCancelled");
    },
  },
  created: function () {},
};
</script>